import React from 'react';
import { Navbar } from '../components/Navbar';
import { ProductReviewsPage } from '../components/ProductReviewsPage';
import { Footer } from '../components/Footer';
export const ProductReviews = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2357">
      <Navbar data-id="element-2358" />
      <ProductReviewsPage data-id="element-2359" />
      <Footer data-id="element-2360" />
    </div>;
};